/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.24.0
 */

export const initialUserNotificationsTranslation = {
    emptyList: '',
    menuTitle: '',
    content: {
        orders: {
            singleTitle: '',
            groupTitle: '',
            overflowTitle: '',
        },
        inquiries: {
            singleTitle: {
                preLink: '',
                afterLink: '',
            },
            groupTitle: '',
            overflowTitle: '',
        },
        edm: {
            connectedEDM: '',
            connectedFor: '',
        },
    },
    linkText: {
        default: '',
        news: '',
        bannerAuth: '',
        cvm: '',
        cashback: '',
    },
    hints: {
        deleteHint: '',
        viewHint: '',
        unviewHint: '',
    },
    header: {
        startLink: '',
        menuTitle: '',
        menuItems: {
            viewAll: '',
            unViewAll: '',
            deleteAll: '',
        },
    },
    footer: {
        newsLink: '',
    },
};
